import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { ReportTags } from "./ReportTags";
import type { InventoryReportItemDto } from "@/api/dtos";
import type { InventoryReportItem } from "./_models/InventoryReport";
import { toInventoryReportItemFromDto } from "./_transformers/toInventoryReportItemFromDto";

/** One inventory report file, parsed into rows; the name "latest" (LATEST) resolves to the newest file. */
export const getInventoryReportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInventoryReport: builder.query<InventoryReportItem[], string>({
      queryFn: async (name) => {
        try {
          const res = await axios.get<InventoryReportItemDto[]>(
            `${backendBase()}/inventory-reports/${encodeURIComponent(name)}`,
            { headers: { Accept: "application/json" } },
          );
          const rows = res.data.map((x) => toInventoryReportItemFromDto(x));
          return { data: rows };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      providesTags: (_result, _error, name) => [
        { type: ReportTags.InventoryReport, id: name },
      ],
    }),
  }),
});

export const getInventoryReport = getInventoryReportApi.endpoints.getInventoryReport;
